import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchStaffHomeArrivalsArgs,
  FetchStaffHomeDayArgs,
} from '../api/staffHome.api';

import {
  fetchStaffHomeArrivals,
  fetchStaffHomeDay,
} from '../api/staffHome.api';

export const staffHomeQueryKeys = createQueryKeys('staffHome', {
  fetchStaffHomeArrivals: (args: FetchStaffHomeArrivalsArgs) => ({
    queryFn: () => fetchStaffHomeArrivals(args),
    queryKey: [args.organizationId, args],
  }),
  fetchStaffHomeDay: (args: FetchStaffHomeDayArgs) => ({
    queryFn: () => fetchStaffHomeDay(args),
    queryKey: [args.organizationId, args],
  }),
});
